export interface RequirementStyle {
  label: string;
  bg: string;
  color: string;
}

export const REQUIREMENT_CONFIG: Record<string, RequirementStyle> = {
  SURGERY:        { label: 'OR',      bg: 'rgb(47, 81, 48)', color: 'rgb(255, 255, 255)' },
  INTENSIVE_CARE: { label: 'ICU',     bg: '#bbdefb', color: '#0d47a1' },
  ONCOLOGY:       { label: 'ONC',     bg: '#e1bee7', color: '#6a1b9a' },
  DIALYSIS:       { label: 'DIALYSE', bg: '#b2dfdb', color: '#00695c' },
  BURN_UNIT:      { label: 'BURN',    bg: '#ffe0b2', color: '#e65100' },
  NURSING:        { label: 'CARE',    bg: '#ffe082', color: '#5d4037' },
  MATERNITY:      { label: 'MATRY',   bg: '#f8bbd0', color: '#ad1457' },
  REHABILITATION: { label: 'REHAB',   bg: '#b2ebf2', color: '#00838f' },
};

export function getRequirementStyle(type: string): RequirementStyle {
  return REQUIREMENT_CONFIG[type] || { label: type, bg: '#e0e0e0', color: '#424242' };
}
